module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("20LeD"))).then(() => parcelRequire('hEqeo'));